<template>
  <div v-if="!permission.capabilities.View" class="animated content-holder">
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> Product View {{ product_name }}</div>
        <b-button-group>
          <b-button v-on:click="routerBack()" class="custom-cancel"
            ><i class="fa fa-times text-danger"></i>
            Cancel
          </b-button>
          <b-button @click="openEditPage(product_id)"
            ><i class="fa fa-save"></i> Edit
          </b-button>
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <h2>{{ product_name }}</h2>
        <b-row>
          <b-col md="4">
            <b-row>
              <b-col>
                <b-form-group
                  id="productCompanyName"
                  label="Company Name"
                  label-class="font-weight-bold pt-0"
                  label-for="custAlias"
                >
                  <b-form-input
                    id="productCompanyName"
                    type="text"
                    v-model="company_name"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="productSKU"
                  label="SKU"
                  label-class="font-weight-bold pt-0"
                  label-for="productSKU"
                >
                  <b-form-input
                    id="productSKU"
                    type="text"
                    v-model="sku"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="productCode"
                  label="Code"
                  label-class="font-weight-bold pt-0"
                  label-for="productCode"
                >
                  <b-form-input
                    id="productCode"
                    type="text"
                    v-model="code"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="productPrice"
                  label="Price"
                  label-class="font-weight-bold pt-0"
                  label-for="productPrice"
                >
                  <b-form-input
                    id="productPrice"
                    type="text"
                    v-model="price"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="productCategoryName"
                  label="Category Name"
                  label-class="font-weight-bold pt-0"
                  label-for="productCategoryName"
                >
                  <b-form-input
                    id="productCategoryName"
                    type="text"
                    v-model="category_name"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="8" class="left-border">
            <b-row>
              <b-col md="6">
                <b-card class="mb-2">
                  <b-card-title>Front Image</b-card-title>
                  <b-card-img
                    v-bind:src="`${uploadImgFront}`"
                    alt="Image"
                    bottom
                  ></b-card-img>
                </b-card>
              </b-col>
              <b-col md="6">
                <b-card class="mb-2">
                  <b-card-title>Back Image</b-card-title>
                  <b-card-img
                    v-bind:src="`${uploadImgBack}`"
                    alt="Image"
                    bottom
                  ></b-card-img>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-card class="mb-2">
                  <b-card-title>Pack Image</b-card-title>
                  <b-card-img
                    v-bind:src="`${uploadImgPack}`"
                    alt="Image"
                    bottom
                  ></b-card-img>
                </b-card>
              </b-col>
              <b-col md="6">
                <b-card class="mb-2">
                  <b-card-title>Pack Image</b-card-title>
                  <b-card-img
                    v-bind:src="`${uploadImgBox}`"
                    alt="Image"
                    bottom
                  ></b-card-img>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-people mr-1"></i>Wallets List</div>
        <router-link to="/wallets/new">
          <b-button variant="primary">
            <i class="fa fa-plus"></i> New
          </b-button>
        </router-link>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <v-client-table
          :columns="columns"
          :data="data"
          :options="options"
          :theme="theme"
          id="dataTable"
        >
          <a
            slot="title"
            class="hyperlink-without-href"
            slot-scope="props"
            title="View"
            @click="openEditPage(props.row.id)"
          >
            {{ props.row.title }}
          </a>
          <c-switch
            slot="active"
            data-on=""
            data-off=""
            variant = "3d" 
            disabled
            slot-scope="props"
            color="success"
            class="mx-1 active-disabled"
            :checked="props.row.active"
            label
          />
          <div slot="action" slot-scope="props">
            <div class="input-group input-group-sm action">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i class="fa fa-cog" aria-hidden="true"></i>
                </template>
                <b-dropdown-item @click="openEditPageWallet(props.row.id)"
                  ><i class="fa fa-edit"></i> Edit</b-dropdown-item
                >
                <b-dropdown-item @click="openDeleteModal(props.row.id)"
                  ><span style="color: #20a8d8;"
                    ><i class="fa fa-trash"></i> Delete</span
                  ></b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>

    <DeleteConfirmModal
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)"
      ref="deleteConfirmModal"
    />
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid";
import { Switch as cSwitch } from "@coreui/vue";
import { router } from "../../router/index";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import ActivityLog from "@/containers/ActivityLog";
import { ClientTable, Event } from "vue-tables-2";
import Modals from "@/shared/Modals.vue";
import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);
Vue.use(ClientTable);

let columns = [
  "action",
  "walletName",
  "walletType",
  "walletCount",
  "walletSegmentUsageCountTotal",
  "active"
];

let headings = {
  action: "",
  walletName: "Name",
  walletType: "Type",
  walletCount: "Count",
  walletSegmentUsageCountTotal: "Segments Used Count",
  active: "Active"
};
let sortable = [
  "walletName",
  "walletCount",
  "walletType",
  "walletSegmentUsageCountTotal",
  "active"
];
let filterable = ["walletName", "walletType"];

export default {
  name: "User",
  components: {
    cSwitch,
    Spinner,
    ActivityLog,
    Modals,
    DeleteConfirmModal,
    Page403
  },
  data() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || "Asia/Bangkok";
    if (window.location.href.includes("/product/view")) {
      var product_id = localStorage.getItem("page_product_id");
      var product_name = localStorage.getItem("page_product_name");
      var category_name = localStorage.getItem("page_category_name");
      var company_name = localStorage.getItem("page_company_name");
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false
        }
      },
      // form: Object.assign({}, formShape),
      feedBack: "secondary",
      isLoading: true,
      product_id: product_id || null,
      product_name: product_name,
      category_name: category_name === undefined ? "NULL" : category_name,
      company_name: company_name === undefined ? "NULL" : company_name,
      isEdit: false,
      sku: null,
      price: null,
      code: null,
      categories: null,
      tags: null,
      manufacturers: null,
      walletSegments: null,
      linkCount: null,
      activatedCount: null,
      companyName: null,
      uploadImgFront: null,
      uploadImgBack: null,
      uploadImgPack: null,
      uploadImgBox: null,
      //wallet
      columns: columns,
      data: [],
      options: {
        columnsClasses: "left-align",
        headings: headings,
        sortable: sortable,
        filterable: filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",

      deleteModalOpen: false,
      deleteModal: {
        modalTitle: "Delete Wallet",
        modalMsg: "",
        loginUserRoleName: loginUserInfo.db.roleName,
        deleteAction: ""
      }
    };
  },
  mounted: function() {
    var that = this;
    that.getPermission();
    if (!that.permission.capabilities.View) {
      return;
    }
    if (that.product_id) {
      that.loadObjects();
      that.getProductsData();
    } else {
      that.isLoading = false;
    }
  },
  computed: {
    formStr() {
      return JSON.stringify(this.form, null, 4);
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    }
  },
  methods: {
    getPermission() {
      let that = this;
      const userPermissionsBasedOnEntity =
        that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if (this.$route.meta && userPermissionsBasedOnEntity) {
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(
          p => p.permissionBaseName === this.$route.meta.permissionBaseName
        );
        if (userPermissionBasedOnEntity) {
          that.permission.permissionBaseNameCapabilities =
            userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability => {
            that.permission.capabilities[capability.label] = capability.value;
          });
        }
      } else {
        router.push("/no-permission-given");
      }
    },
    routerBack() {
      this.$router.go(-1);
    },
    openEditPage: function(id) {
      localStorage.setItem("page_products_id", id);
      router.push("/products/product/edit");
    },
    openEditPageWallet: function(id) {
      this.id = id;
      this.wallet_id = this.data[id].wallet_id;
      localStorage.setItem("page_wallet_id", this.wallet_id);
      router.push("/wallets/edit");
    },
    openDeleteModal: function(id) {
      let that = this;
      that.deleteModal.deleteAction = "";
      that.id = id;
      that.wallet_id = that.data[id].wallet_id;
      that.title = that.data[id].walletName;
      that.deleteModal.modalMsg = "Delete the Wallet '" + that.title + "' ?";
      that.$refs.deleteConfirmModal.openModal();
    },
    getDeleteAction(data) {
      let that = this;
      if (data && data.deleteAction) {
        that.deleteModal.deleteAction = data.deleteAction;
        that.prepareToDeleteWallet();
      }
    },
    prepareToDeleteWallet: async function() {
      let that = this;
      this.$refs.infoModal.openModal();
      that.changeInfoModalContent(
        "loading",
        "Checking...",
        "Checking the orphaned Records"
      );

      let checkOrphanRecordsOfWalletResult = await that.checkOrphanRecordsOfWallet(
        that.wallet_id,
        that.title
      );
      if (
        checkOrphanRecordsOfWalletResult == "error" ||
        that.walletHasOrphanRecords
      ) {
        return;
      } else {
        that.deleteWallet();
      }
    },
    deleteWallet() {
      let that = this;
      that.$refs.infoModal.openModal();
      that.changeInfoModalContent(
        "loading",
        "Processing...",
        that.deleteModal.deleteAction == "MARK-AS-DELETED"
          ? "Deleting the wallet (" + that.title + ")"
          : "Deleting the wallet (" + that.title + ") permenently"
      );
      let wallet_id = that.wallet_id;
      let method = "PUT";
      let pathTemplate =
        that.deleteModal.deleteAction == "MARK-AS-DELETED"
          ? "/wallets/" + wallet_id + "/mark-as-deleted"
          : "/wallets/" + wallet_id + "/delete";
      let additionalParams = {};
      let pathParams = {};
      let body = {
        orphanRecords: that.orphanRecords,
        updateBy: that.loginUserInfo.login_username
      };
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result) {
          if (result.data.status) {
            that.changeInfoModalContent(
              "success",
              "Deleted success!",
              "The Wallet data has been deleted"
            );
            setTimeout(that.$refs.infoModal.closeModal(), 1500);

            that.showSuccessMsg();
            that.loadAndUpdateTableListAfterItemDelete(that);
          } else {
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + result.data.message
            );
          }
        })
        .catch(function(error) {
          that.isLoading = false;
          that.changeInfoModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + error.message
          );
        });
    },
    getProductsData: function() {
      var method = "GET";
      var pathTemplate = "/products/" + this.product_id;
      var additionalParams = {};
      var pathParams = {};
      var productsData = [];
      var that = this;
      let img = "/img/not_found.png";
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          productsData = result["data"]["data"];
          that.sku = productsData.sku;
          that.price = productsData.price;
          that.code = productsData.code;
          that.pro_active = productsData.pro_active;
          that.uploadImgFront = img;
          that.uploadImgBack = img;
          that.uploadImgPack = img;
          that.uploadImgBox = img;
          that.uploadImgFront =
            productsData.product_imgFront.length != 0
              ? productsData.product_imgFront.filepath
              : img;
          that.uploadImgBack =
            productsData.product_imgBack.length != 0
              ? productsData.product_imgBack.filepath
              : img;
          that.uploadImgPack =
            productsData.product_imgPack.length != 0
              ? productsData.product_imgPack.filepath
              : img;
          that.uploadImgBox =
            productsData.product_imgBox.length != 0
              ? productsData.product_imgBox.filepath
              : img;
          //This is where you would put a success callback
          that.isLoading = false;
        })
        .catch(function(error) {
          that.isLoading = false;
          //This is where you would put an error callback
        });
    },
    loadObjects: function() {
      var that = this;
      var method = "GET";
      var pathTemplate = "/wallets";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "product_id",
                comparisonOperator: "=",
                value: that.product_id
              }
            ]
          })
        }
      };
      var pathParams = {};
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          that.data = result["data"]["data"];
          that.data = result["data"]["data"].map((elem, index) => {
            elem.wallet_id = elem.id;
            elem.id = index;
            return elem;
          });
          that.isLoading = false;
        })
        .catch(function(error) {
          
        });
    }
  }
};
</script>

<style scoped>
.btn.disabled {
  cursor: auto;
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  border: 1px solid #a4acb5;
}
@media only screen and (max-width: 600px) {
  .custom-header {
    flex-direction: column;
    align-items: inherit;
  }
  .custom-header > div:first-child {
    margin-bottom: 10px;
  }
}
.custom-cancel {
  border-radius: 0.25rem 0 0 0.25rem;
}
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}
</style>

<style>
#language {
  margin-top: 15px;
}
.custom-header {
  display: flex;
  justify-content: space-between;
}
select {
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
}
/* For IE10 */
select::-ms-expand {
  display: none;
}
.blue {
  color: #20a8d8;
}
.left-border {
  border-left: 1px solid #c8ced3;
}
</style>
